module.exports = __webpack_public_path__ + "static/media/40-7.22082111.mp3";